/* ═══════════════════════════════════════════
   GODENT THEME — MAIN JS v1.0
   Handles: Cart, Nav, Modals, Filters, Wishlist, Toast
═══════════════════════════════════════════ */

'use strict';

// ── TOAST ──
function showToast(msg, type = 'success') {
  const t = document.getElementById('toast');
  if (!t) return;
  t.innerHTML = msg;
  t.style.borderLeftColor = type === 'error' ? 'var(--red)' : 'var(--green)';
  t.classList.add('show');
  clearTimeout(t._timeout);
  t._timeout = setTimeout(() => t.classList.remove('show'), 3500);
}

// ── NAV MENUS ──
function toggleMenu(liId) {
  const li = document.getElementById(liId);
  const wasOpen = li.classList.contains('open');
  closeMenus();
  if (!wasOpen) li.classList.add('open');
}
function closeMenus() {
  document.querySelectorAll('.nav-links > li').forEach(li => li.classList.remove('open'));
}
document.addEventListener('click', e => {
  if (!e.target.closest('.nav-links')) closeMenus();
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeMenus(); closeMobileMenu(); closeCart(); closeModal(); }
});

// ── MOBILE DRAWER ──
function toggleMobileMenu() {
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mob-overlay');
  const ham = document.getElementById('ham-btn');
  if (!drawer) return;
  const opening = !drawer.classList.contains('open');
  drawer.classList.toggle('open', opening);
  overlay.classList.toggle('show', opening);
  ham && ham.classList.toggle('open', opening);
  document.body.style.overflow = opening ? 'hidden' : '';
}
function closeMobileMenu() {
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mob-overlay');
  const ham = document.getElementById('ham-btn');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('show');
  if (ham) ham.classList.remove('open');
  document.body.style.overflow = '';
}
function toggleMobSub(id) {
  const sub = document.getElementById(id);
  const arr = document.getElementById('marr-' + id.replace('msub-', ''));
  const opening = !sub.classList.contains('open');
  sub.classList.toggle('open', opening);
  if (arr) arr.classList.toggle('rot', opening);
}

// ── CART (Shopify AJAX API) ──
const Cart = {
  data: { items: [], total_price: 0, item_count: 0 },

  async init() {
    try {
      const res = await fetch('/cart.js');
      this.data = await res.json();
    } catch (e) {
      // offline / non-Shopify preview — use local fallback
      this.data = { items: [], total_price: 0, item_count: 0 };
    }
    this.updateCount();
  },

  async add(variantId, qty = 1) {
    try {
      if (!variantId || variantId == 0) {
        showToast('⚠️ Please select a product variant first.', 'error');
        return;
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        const msg = errData.description || errData.message || 'Could not add to cart.';
        showToast('⚠️ ' + msg, 'error');
        return;
      }
      await this.refresh();
      showToast('✅ Added to cart! <a href="/cart" style="color:#fff;font-weight:700;text-decoration:underline;margin-left:6px">View Cart →</a>');
    } catch (e) {
      showToast('⚠️ Could not add to cart. Try again.', 'error');
    }
  },

  async update(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      this.data = await res.json();
      this.updateCount();
      this.renderDrawer();
    } catch (e) { console.warn('Cart update error', e); }
  },

  async remove(key) {
    await this.update(key, 0);
    showToast('🗑️ Item removed');
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      this.data = await res.json();
      this.updateCount();
      this.renderDrawer();
    } catch (e) {}
  },

  updateCount() {
    const count = this.data.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = count);
  },

  openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    this.renderDrawer();
    drawer.classList.add('open');
    overlay && overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  },

  renderDrawer() {
    const body = document.getElementById('cart-body');
    const foot = document.getElementById('cart-foot');
    if (!body) return;
    const items = this.data.items || [];
    if (!items.length) {
      body.innerHTML = `<div class="cart-empty">
        <div class="ce-icon">🛒</div>
        <p>Your cart is empty.<br>Add some products to get started!</p>
        <button onclick="closeCart();window.location='/collections/all'" class="btn-p">Browse Products</button>
      </div>`;
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = items.map(item => `
      <div class="cart-item">
        <div class="ci-icon">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : `<span style="font-size:28px">🦷</span>`}
        </div>
        <div class="ci-info">
          <div class="ci-name">${item.product_title}</div>
          <div class="ci-brand">${item.vendor || ''} ${item.variant_title && item.variant_title !== 'Default Title' ? '· ' + item.variant_title : ''}</div>
          <div class="ci-row">
            <span class="ci-price">EGP ${(item.final_line_price / 100).toLocaleString('en-EG', {maximumFractionDigits:0})}</span>
            <div class="ci-qty">
              <button class="ci-qb" onclick="Cart.update('${item.key}', ${item.quantity - 1})">−</button>
              <input class="ci-qv" type="number" value="${item.quantity}" min="1" onchange="Cart.update('${item.key}', this.value)"/>
              <button class="ci-qb" onclick="Cart.update('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>
        <button class="ci-del" onclick="Cart.remove('${item.key}')" title="Remove">✕</button>
      </div>`).join('');
    const total = (this.data.total_price / 100).toLocaleString('en-EG', {maximumFractionDigits:0});
    document.getElementById('cart-total') && (document.getElementById('cart-total').textContent = `EGP ${total}`);
    if (foot) foot.style.display = 'block';
  },

  orderViaWA() {
    const items = this.data.items || [];
    if (!items.length) { showToast('Cart is empty!', 'error'); return; }
    const lines = items.map(i => `- ${i.product_title} x${i.quantity} = EGP ${(i.final_line_price/100).toFixed(0)}`).join('\n');
    const total = (this.data.total_price / 100).toFixed(0);
    const msg = `Hello GoDent! I'd like to order:\n\n${lines}\n\nTotal: EGP ${total}`;
    const num = (window.GoDent && window.GoDent.whatsapp) ? window.GoDent.whatsapp.replace(/\D/g,'') : '201013708341';
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  }
};

function openCart() { Cart.openDrawer(); }
function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('show');
  document.body.style.overflow = '';
}

// ── PRODUCT MODAL ──
function openModal(productHandle) {
  // In Shopify, fetch product JSON
  fetch(`/products/${productHandle}.js`)
    .then(r => r.json())
    .then(p => renderModal(p))
    .catch(() => {
      // preview fallback
      renderModalFallback(productHandle);
    });
}
function renderModal(p) {
  const variant = p.variants && p.variants[0];
  const price = variant ? (variant.price / 100) : 0;
  const comparePrice = variant && variant.compare_at_price ? (variant.compare_at_price / 100) : null;
  const disc = comparePrice ? Math.round((1 - price/comparePrice)*100) : 0;
  const img = p.images && p.images[0] ? p.images[0].src : null;
  document.getElementById('modal-content').innerHTML = `
    ${img ? `<img class="modal-img" src="${img}" alt="${p.title}">` : `<div class="modal-icon">🦷</div>`}
    <div class="modal-brand">${p.vendor}</div>
    <div class="modal-name">${p.title}</div>
    <div class="modal-rat"><span class="modal-stars">★★★★★</span> 4.8 · Verified Purchase</div>
    <div class="modal-price-row">
      <span class="modal-now">EGP ${price.toLocaleString('en-EG',{maximumFractionDigits:0})}</span>
      ${comparePrice ? `<span class="modal-was">EGP ${comparePrice.toLocaleString('en-EG',{maximumFractionDigits:0})}</span><span class="modal-disc">-${disc}% OFF</span>` : ''}
    </div>
    ${p.description ? `<div class="modal-desc">${p.description.replace(/<[^>]*>/g,'').substring(0,200)}...</div>` : ''}
    <div class="modal-qty">
      <button class="qty-btn" onclick="chgQty(-1)">−</button>
      <input type="number" class="qty-val" id="modal-qty-val" value="1" min="1" max="99"/>
      <button class="qty-btn" onclick="chgQty(1)">+</button>
    </div>
    <div class="modal-actions">
      <button class="btn-atc" onclick="addToCartModal(${variant ? variant.id : 0})">🛒 Add to Cart</button>
      <button class="btn-wl" onclick="toggleWishlist('${p.handle}',this)" id="modal-wl-btn">🤍</button>
    </div>
    <div class="modal-features">
      <div class="mf-item"><span>🚚</span> Fast nationwide delivery</div>
      <div class="mf-item"><span>✅</span> 100% authentic</div>
      <div class="mf-item"><span>↩️</span> 7-day returns</div>
      <div class="mf-item"><span>💬</span> WhatsApp support</div>
    </div>`;
  showModalEl();
}
function renderModalFallback(id) {
  // used in static HTML preview
  document.getElementById('modal-content').innerHTML = `
    <div class="modal-icon">🦷</div>
    <div class="modal-brand">GoDent</div>
    <div class="modal-name">Product Preview</div>
    <div class="modal-rat"><span class="modal-stars">★★★★★</span> 4.9</div>
    <div class="modal-desc">This is a preview. Full product details load on the live Shopify store.</div>
    <div class="modal-actions">
      <button class="btn-atc" onclick="showToast('Add to cart works on live store!')">🛒 Add to Cart</button>
    </div>`;
  showModalEl();
}
function showModalEl() {
  const m = document.getElementById('prod-modal');
  if (m) { m.classList.add('show'); document.body.style.overflow = 'hidden'; }
}
function closeModal() {
  document.getElementById('prod-modal')?.classList.remove('show');
  document.body.style.overflow = '';
}
function chgQty(d) {
  /* Works for both modal (modal-qty-val) and product page (pdp-qty) */
  const el = document.getElementById('pdp-qty') || document.getElementById('modal-qty-val');
  if (!el) return;
  el.value = Math.max(1, Math.min(99, parseInt(el.value || 1) + d));
}
async function addToCartModal(variantId) {
  const el = document.getElementById('modal-qty-val') || document.getElementById('pdp-qty');
  const qty = parseInt(el?.value || 1);
  closeModal();
  await Cart.add(variantId, qty);
}

// ── WISHLIST (localStorage) ──
const Wishlist = {
  get() { try { return JSON.parse(localStorage.getItem('gd_wishlist') || '[]'); } catch(e) { return []; } },
  save(list) { try { localStorage.setItem('gd_wishlist', JSON.stringify(list)); } catch(e) {} },
  has(id) { return this.get().includes(String(id)); },
  toggle(id, btn) {
    const list = this.get();
    const idStr = String(id);
    const idx = list.indexOf(idStr);
    if (idx > -1) {
      list.splice(idx, 1);
      if (btn) btn.textContent = '🤍';
      showToast('Removed from wishlist');
    } else {
      list.push(idStr);
      if (btn) btn.textContent = '❤️';
      showToast('❤️ Added to wishlist!');
    }
    this.save(list);
  }
};
function toggleWishlist(id, btn) { Wishlist.toggle(id, btn); }

// ── MOBILE FILTER DRAWER ──
function openMobFilter() {
  const d = document.getElementById('mob-filter-drawer');
  if (d) { d.classList.add('open'); document.body.style.overflow = 'hidden'; }
}
function closeMobFilter() {
  document.getElementById('mob-filter-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ── FAQ ACCORDION ──
function toggleFAQ(id) {
  const el = document.getElementById('faq-' + id);
  if (!el) return;
  const wasOpen = el.classList.contains('open');
  document.querySelectorAll('.faq-i').forEach(x => x.classList.remove('open'));
  if (!wasOpen) el.classList.add('open');
}

// ── SYLLABUS (Course detail) ──
function toggleSyllabus(id) {
  const el = document.getElementById('syl-' + id);
  if (!el) return;
  const wasOpen = el.classList.contains('open');
  document.querySelectorAll('.syllabus-item').forEach(x => x.classList.remove('open'));
  if (!wasOpen) el.classList.add('open');
}

// ── COUNTDOWN ──
function startCountdown(targetSecs) {
  let s = targetSecs || (8 * 3600 + 42 * 60 + 17);
  function tick() {
    s = s > 0 ? s - 1 : 86399;
    ['cd-h','cd-m','cd-s'].forEach((id, i) => {
      const vals = [Math.floor(s/3600), Math.floor((s%3600)/60), s%60];
      const el = document.getElementById(id);
      if (el) el.textContent = String(vals[i]).padStart(2, '0');
    });
  }
  tick();
  return setInterval(tick, 1000);
}

// ── SCROLL REVEAL ──
function initReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const delay = parseInt(e.target.dataset.delay || 0) * 80;
        setTimeout(() => e.target.classList.add('visible'), delay);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.reveal').forEach((el, i) => {
    el.dataset.delay = i % 5;
    io.observe(el);
  });
}

// ── SEARCH ──
function doSearch(q) {
  if (!q.trim()) return;
  window.location.href = `/search?q=${encodeURIComponent(q.trim())}&type=product`;
}

// ── ACCOUNT TABS ──
function switchAccTab(id, btn) {
  document.querySelectorAll('.acc-tab').forEach(b => b.classList.remove('on'));
  document.querySelectorAll('.acc-panel').forEach(p => p.classList.remove('on'));
  if (btn) btn.classList.add('on');
  const panel = document.getElementById('panel-' + id);
  if (panel) panel.classList.add('on');
}

// ── PRODUCT FILTERS (collection page) ──
function applyFilter(type, val, el) {
  if (el) {
    document.querySelectorAll(`[data-filter-type="${type}"]`).forEach(b => b.classList.remove('on'));
    el.classList.add('on');
  }
  const url = new URL(window.location.href);
  if (val && val !== 'all') { url.searchParams.set(type, val); }
  else { url.searchParams.delete(type); }
  window.location.href = url.toString();
}

// ── CLINIC FORM ──
function submitClinicForm() {
  const fn = document.getElementById('cf-fn')?.value.trim();
  const cn = document.getElementById('cf-cn')?.value.trim();
  const ph = document.getElementById('cf-ph')?.value.trim();
  if (!fn || !cn || !ph) { showToast('⚠️ Please fill required fields', 'error'); return; }
  const cy = document.getElementById('cf-cy')?.value || '—';
  const tp = document.getElementById('cf-tp')?.value || '—';
  const vo = document.getElementById('cf-vo')?.value || '—';
  const em = document.getElementById('cf-em')?.value || '—';
  const msg = `Hello GoDent! Clinic Account Application:\n\nName: ${fn}\nClinic: ${cn}\nPhone: ${ph}\nCity: ${cy}\nType: ${tp}\nVolume: ${vo}\nEmail: ${em}`;
  const num = (window.GoDent && window.GoDent.whatsapp) ? window.GoDent.whatsapp.replace(/\D/g,'') : '201013708341';
  window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  showToast('✅ Application sent via WhatsApp!');
}

// ── CONTACT FORM ──
function submitContact() {
  const nm = document.getElementById('ct-nm')?.value.trim();
  const msg_t = document.getElementById('ct-msg')?.value.trim();
  if (!nm || !msg_t) { showToast('⚠️ Please fill required fields', 'error'); return; }
  const ph = document.getElementById('ct-ph')?.value || '';
  const sub = document.getElementById('ct-sub')?.value || 'Inquiry';
  const em = document.getElementById('ct-em')?.value || '';
  const msg = `Hello GoDent! [${sub}]\n\nFrom: ${nm}${ph ? '\nPhone: ' + ph : ''}${em ? '\nEmail: ' + em : ''}\n\nMessage:\n${msg_t}`;
  const num = (window.GoDent && window.GoDent.whatsapp) ? window.GoDent.whatsapp.replace(/\D/g,'') : '201013708341';
  window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  showToast('✅ Message sent via WhatsApp!');
}

// ── COURSE ENROLL ──
function enrollCourse(name, price) {
  const num = (window.GoDent && window.GoDent.whatsapp) ? window.GoDent.whatsapp.replace(/\D/g,'') : '201013708341';
  const msg = `Hello GoDent! I'd like to enroll in:\n\nCourse: ${name}\nPrice: ${price}\n\nPlease send me enrollment details.`;
  window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  Cart.init();
  initReveal();

  // Countdown (offers page)
  if (document.getElementById('cd-h')) startCountdown();

  // Keyboard: close on ESC
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeCart();
      closeModal();
      closeMobileMenu();
    }
  });

  // Search on Enter
  document.querySelectorAll('.search-input').forEach(inp => {
    inp.addEventListener('keydown', e => {
      if (e.key === 'Enter') doSearch(e.target.value);
    });
  });

  // Cart overlay click
  document.getElementById('cart-overlay')?.addEventListener('click', closeCart);
  document.getElementById('prod-modal-overlay')?.addEventListener('click', closeModal);

  // Mark wishlist items
  document.querySelectorAll('[data-wl-id]').forEach(btn => {
    if (Wishlist.has(btn.dataset.wlId)) btn.textContent = '❤️';
  });
});
